import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins, SYS_BORDER_RADIUS_MAX, SYS_BORDER_WIDTH_100, SYS_SIZE_FIXED_600 } from '@oneaudi/unified-web-alpha-common';
export const StyledButton = styled.button `
  margin: ${(props) => getMargins(props.$margin)};
  width: ${SYS_SIZE_FIXED_600};
  height: ${SYS_SIZE_FIXED_600};
  border-radius: ${SYS_BORDER_RADIUS_MAX};
  flex-shrink: 0;
  cursor: pointer;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, box-shadow, background;
  ${(props) => css `
    box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${props.theme.cmp.color.action.componentButton.surface.stroke.idle};
    color: ${props.theme.cmp.color.action.componentButton.foreground.icon.idle};
    background-color: ${props.theme.cmp.color.action.componentButton.surface
    .fill.idle};

    &:hover:not(:disabled) {
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.action.componentButton.surface.stroke.hover};
      color: ${props.theme.cmp.color.action.componentButton.foreground.icon
    .hover};
      background-color: ${props.theme.cmp.color.action.componentButton.surface
    .fill.hover};
    }

    &:active:not(:disabled) {
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.action.componentButton.surface.stroke.pressed};
      color: ${props.theme.cmp.color.action.componentButton.foreground.icon
    .pressed};
      background-color: ${props.theme.cmp.color.action.componentButton.surface
    .fill.pressed};
    }

    &:disabled {
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.action.componentButton.surface.stroke.disabled};
      color: ${props.theme.cmp.color.action.componentButton.foreground.icon
    .disabled};
      background-color: ${props.theme.cmp.color.action.componentButton.surface
    .fill.disabled};
      cursor: not-allowed;
    }
  `}
`;
//# sourceMappingURL=index.styles.js.map